export const LEGACY_PAGINATION_KEYS = [
	'rozcestnik',
	'search-all-types',
] as const;

export type LegacyPaginationKey = (typeof LEGACY_PAGINATION_KEYS)[number];

export const LEGACY_PAGINATION_KEY_SET = new Set<string>(
	LEGACY_PAGINATION_KEYS
);
